<template>
  <div>
    <d-row no-gutters>
      <d-col lg="3" md="5" class="auth-form mx-auto my-auto">
        <d-card>
          <d-card-body>
            <!-- Logo -->
            <img
              class="auth-form__logo d-table mx-auto mb-3"
              src="@/assets/images/logos/logo-partner.svg"
              style="max-width: 9rem"
            />

            <!-- Title -->
            <h5 class="auth-form__title text-center mb-4">Redefinir Senha</h5>
            <!-- Loader -->
            <div v-if="loading">
              <loader :is-loading="loading"></loader>
            </div>
            <div v-else>
            <!-- Form Fields -->
              <d-form>
                <ValidationObserver ref="validationForm">
                  <div class="form-group mb-4">
                    <ValidationProvider rules="required|email" v-slot="{errors, invalid}">
                      <d-input
                        :class="validatedForm | showValidateError(invalid)"
                        v-model="email"
                        type="email"
                        placeholder="E-mail"
                      />
                      <div class="invalid-feedback d-block" v-if="validatedForm">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <d-form-text
                      class="text-muted text-center"
                    >Você receberá por e-mail as instruções de redefinição.</d-form-text>
                  </div>
                  <button
                    v-on:click.stop="LostPassword($event)"
                    type="submit"
                    class="btn btn-pill btn-accent d-table mx-auto"
                  >REDEFINIR</button>
                </ValidationObserver>
              </d-form>
            </div>
          </d-card-body>
        </d-card>

        <!-- Meta -->
        <div class="auth-form__meta d-flex mt-4">
          <router-link class="mx-auto" :to="{ name: 'login' }">Voltar para o Login</router-link>
        </div>
      </d-col>
    </d-row>
  </div>
</template>


<script>
export default {
  name: "forgot-password",
  data: function() {
    return {
      loading: false,
      validatedForm: false,
      email: undefined
    };
  },
  computed: {},
  mounted() {},
  methods: {
    LostPassword: function(e) {
      e.preventDefault();
      //start loader
      this.validatedForm = true;
      this.$refs.validationForm.validate().then(valid => {
        if (valid) {
          this.CallLostPasswordAPI();
        }
      });
    },
    CallLostPasswordAPI: function() {
      this.loading = true;
      this.$store
        .dispatch("LostPassword", {email: this.email})
        .then(
          () => {
            this.$makeToast(
              `Siga as instruções enviadas para o e-mail ${this.email} para redefinir sua senha.`,
              "success",
              "Redefinição de senha",
            );
            setTimeout(() => {
              this.$router.push({
                name: "login",
                query: {
                  email: this.email
                }
              });
            }, 6000);
          },
          error => {
            this.$makeToast(
              "Não foi possível recuperar sua senha.",
              'danger',
              "Redefinição de senha",
              error
            );
          }
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/forgotPassword.vue